<template>
  <div class="section">
    <div class="container custom-container">
      <div class="columns">
        <div class="column is-5">
          <!-- Greeting -->
          <p>Welcome, {{userName}}!</p>
          <!-- Activity -->
          <h1 class="title">
            <Loader v-bind:isLoading="isActivityLoading" />
            Latest Activity
          </h1>
          <ul>
            <li v-for="sim in activity" :key="sim.id">
              <span v-if="sim.status <= 1" class="has-text-weight-bold">{{ sim.title }}</span>
              <router-link v-else :to="{name: 'result', params: { id: sim.id}}" class="has-text-weight-bold">{{ sim.title }}</router-link>
              - {{ sim.created_at | formatDate }}
                <font-awesome-icon v-if="sim.status == 0" icon="hourglass-start" />
                <font-awesome-icon v-if="sim.status == 1" icon="hourglass-half" />
                <font-awesome-icon v-if="sim.status == 2" icon="check" class="has-text-success" />
                <font-awesome-icon v-if="sim.status == 4" icon="times" class="has-text-danger" />
            </li>
          </ul>
          <router-link :to="{name: 'activity'}" class="button is-primary">See All</router-link>
          <!-- Search -->
          <Search />
        </div>
        <div class="column">
          <!-- New Simulation -->
          <h1 class="title">
            <Loader v-bind:isLoading="isActivityLoading" />
            New Simulation
          </h1>
          <div v-if="canCreateSimulation">
            <p class="before-button">
              Available tokens:
              <span class="tag is-light">{{tokens_available}} tokens</span>
            </p>
            <router-link :to="{name: 'simulation'}" class="button is-primary">Create</router-link>
          </div>
          <p v-else>{{errorMessage}}</p>
          <!-- Materials -->
          <h1 class="title">Materials</h1>
          <router-link :to="{name: 'materials'}" class="button is-primary">Manage</router-link>
          <hr />
          <!-- Support -->
          <div>
            <h1 class="title">Support</h1>
            <p class="before-button">
              To create a new request for support please click the link below, which will open a new window.
            </p>
            <a
              class="button is-primary"
              href="https://www.wrike.com/form/eyJhY2NvdW50SWQiOjI0Mjk1ODQsInRhc2tGb3JtSWQiOjIyMzI2NX0JNDcxMTAwNjIyNzEzOQk3MzcwZTViZGY4YTAwZDJiYzU4NjZlMmYxNDc1OTNlZjc5M2E2NTFkNzA2MTQ3YzNlMmFhODVmMDlkYTFiOGZh"
              rel="noopener noreferrer"
              target="_blank">
              Request Support
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import config from '@/config/apollo-config';
import gql from 'graphql-tag';
import Loader from '@/components/Loader.vue';
import Search from '@/components/Search.vue';
import apiCall from '../lib/remote-calls';

export default {
  components: {
    Loader,
    Search,
  },
  data() {
    return {
      canCreateSimulation: false,
      isActivityLoading: false,
      isAccountLoading: false,
      errorMessage: '',
      activity: [],
      subscription_status: '',
      tokens_available: 0,
    };
  },
  methods: {
    async requestActivity() {
      this.isActivityLoading = true;
      try {
        const response = await apiCall('GET', 'simulations/latest');
        this.activity = response.data.simulations;
      } catch (error) {
        console.error(error);
      }
      this.isActivityLoading = false;
    },
    async requestAccountDetails() {
      this.isAccountLoading = true;
      try {
        const response = await this.$apollo.query({
          query: gql`
          query getUserSubscription($product_name: ProductName!) {
            account: getUserSubscription(product_name: $product_name) {
              product_name
              total_tokens
              tokens_used
              tokens_available
              status
              expiration_datetime
            }
          }`,
          variables: {
            product_name: config.productName,
          },
        });
        const { account } = response.data;
        if (account != null) {
          this.subscription_status = account.status;
          this.tokens_available = account.tokens_available;
          if (this.tokens_available > 0) {
            this.canCreateSimulation = true;
          } else {
            this.errorMessage = 'Please get in touch with a commercial representative for tokens to run simulations.';
          }
        } else {
          this.errorMessage = 'No subscription information found. Please get in touch with a commercial representative.';
        }
      } catch (error) {
        console.error(error);
      }
      this.isAccountLoading = false;
    },
  },
  mounted() {
    this.requestActivity();
    this.requestAccountDetails();
  },
  computed: mapState({
    userName: (state) => {
      if (state.iam.user) {
        return state.iam.user.name;
      }
      return 'Test';
    },
  }),
};
</script>

<style scoped>
ul {
  list-style: disc inside;
  padding-bottom: 1em;
}
ul > li {
  padding-bottom: 0.5em;
}
h1.title:not(:first-child) {
  margin-top: 1em;
}
p.before-button {
  margin-bottom: 1em;
}
</style>
